var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerbia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C6.84042 0 2.44191 3.2565 0.746391 7.82611H23.2537C21.5581 3.2565 17.1596 0 12 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10303 6.78262V12.7688C3.10303 16.174 7.55152 17.2174 7.55152 17.2174C7.55152 17.2174 12 16.174 12 12.7688V6.78262H3.10303Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94278 7.8261H10.1602V5.73913L9.11672 6.26085L7.55151 4.69565L5.98626 6.26085L4.94278 5.73913V7.8261Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 13.6023L7.5652 10.211L4.17389 13.6023L5.28065 14.7091L7.5652 12.4245L9.84975 14.7091L10.9565 13.6023Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 10.4348H9.3742C9.46317 10.2812 9.51492 10.1034 9.51492 9.91317C9.51492 9.3368 9.04772 8.86969 8.47144 8.86969C8.07323 8.86969 7.72744 9.09272 7.55151 9.42061C7.37559 9.09277 7.0298 8.86969 6.63159 8.86969C6.05531 8.86969 5.58811 9.3368 5.58811 9.91317C5.58811 10.1034 5.63986 10.2813 5.72883 10.4348H4.17389C4.17389 11.0111 4.67587 11.4783 5.25211 11.4783H5.21737C5.21737 12.0546 5.68453 12.5218 6.26086 12.5218C6.26086 13.032 6.62733 13.456 7.11131 13.5467L6.28912 15.4031C6.68315 15.5633 7.11375 15.6522 7.56525 15.6522C8.01675 15.6522 8.44734 15.5633 8.84137 15.4031L8.01919 13.5467C8.50317 13.4561 8.86964 13.0321 8.86964 12.5218C9.44597 12.5218 9.91312 12.0546 9.91312 11.4783H9.87839C10.4546 11.4783 10.9565 11.0111 10.9565 10.4348Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/serbia.3921e6bd1caadbfda8ecc5a492ad30f2.svg";
export { ForwardRef as ReactComponent };